import { FC, useState } from "react";
import "./NewsCard.scss";

interface INewsCardProps {
  title: string;
  date: string;
  content: any[];
}

export const NewsCard: FC<INewsCardProps> = ({ title, date, content }) => {
  const [showContent, setShowContent] = useState<boolean>(false);
  return (
    <div className="news-card">
      <span className="news-card__date">{date}</span>
      <span
        className={`news-card__title ${
          showContent ? "news-card__title-underline" : ""
        }`}
      >
        {title}
      </span>
      <div className="cta">
        <button
          onClick={() => setShowContent(!showContent)}
          className="cta__btn cta__btn-green-outline news-card-btn"
        >
          {showContent ? (
            <>
              <span>View Less</span>
              <i className="fas fa-chevron-up"></i>
            </>
          ) : (
            <>
              <span>View More</span>
              <i className="fas fa-chevron-down"></i>
            </>
          )}
        </button>
      </div>
      <div className={`news-card__content ${!showContent && "hidden"}`}>
        {content.map((item: any) => {
          return item.type === "p" ? (
            <p>{item.text}</p>
          ) : (
            <ul>
              {item.listItems.map((li: any) => (
                <li>{li}</li>
              ))}
            </ul>
          );
        })}
      </div>
    </div>
  );
};
